import { Injectable } from "@angular/core";
import { PlanoVistoria } from "@tivic-team/manager-ts/dist/mob/entities/vistoria/plano-vistoria.entity";
import { PlanoVistoriaItemDefeitoDto } from "app/model/dtos/mob/plano-vistoria-item-defeito.dto";
import { PlanoVistoriaItemDto } from "app/model/dtos/mob/plano-vistoria-item.dto";
import { PlanoVistoriaController } from '../../controllers/mob/plano-vistoria.controller';
import { LoaderService } from "../loader.service";
import { PlanoVistoriaSearch } from './plano-vistoria.search';

@Injectable()
export class PlanoVistoriaService {

    constructor(
        private _planoVistoriaController: PlanoVistoriaController,
        private _loaderService: LoaderService
    ) { }

    async find(planoVistoriaSeach: PlanoVistoriaSearch): Promise<Array<PlanoVistoria>> {
        try {
            return await this._planoVistoriaController.find(planoVistoriaSeach && planoVistoriaSeach.getFilters()); }
        catch (error) { 
            return null; 
        }
    }

    async get(cdPlanoVistoria: number): Promise<PlanoVistoria> {
        this._loaderService.show();
        return this._planoVistoriaController.get(cdPlanoVistoria).finally(() => this._loaderService.hide());
    }

    async delete(cdPlanoVistoria:number):Promise<PlanoVistoria> {
        this._loaderService.show();
        return this._planoVistoriaController.delete(cdPlanoVistoria).finally(() => {this._loaderService.hide();});
    }

    async save(planoVistoria:PlanoVistoria):Promise<PlanoVistoria>{
        this._loaderService.show();
        if(!planoVistoria.cdPlanoVistoria)
            return this._planoVistoriaController.create(planoVistoria).finally(() => this._loaderService.hide());
        else
            return this._planoVistoriaController.update(planoVistoria).finally(() => this._loaderService.hide());
    }

    async getItens(cdPlanoVistoria: number): Promise<Array<PlanoVistoriaItemDto>> {
        this._loaderService.show();
        return this._planoVistoriaController.getItens(cdPlanoVistoria).finally(() => this._loaderService.hide());
    }

    async getItemDefeitos(cdPlanoVistoria: number, cdVistoriaItem:number): Promise<Array<PlanoVistoriaItemDefeitoDto>> {
        this._loaderService.show();
        return this._planoVistoriaController.getItemDefeitos(cdPlanoVistoria, cdVistoriaItem).finally(() => this._loaderService.hide());
    }

}